<template>

  <footer class="footer">
    <div class="footer__name">Claudia De Medio ©</div>
    <nav class="footer__nav">
      <router-link to="/">Portfolio</router-link>
      <router-link to="/resume">Resume</router-link>
      <router-link to="/contacts">Contacts</router-link>
    </nav>
    <div class="footer__top" @click="scrollToTop()"></div>
  </footer>

</template>

<script>

  export default {
    name: 'Footer',
    methods: {
      scrollToTop() {
        document.body.scrollIntoView({
          behavior: 'smooth'
        })
      }
    }
  }

</script>

<style scoped lang="scss">

  @import '@/scss/app.scss';

  .footer {
    @include container;
    justify-content: center;
    align-items: center;
    padding: 50px 0;
    border-top: 1px solid #e6e5e0;
  }

  .footer__name {
    position: absolute;
    left: 0;
  }

  .footer__nav {
    text-align: center;

    @include mq(small) {
      display: none;
    }
  }

  .footer__nav a {
    @include ui;
    text-decoration: none;
    padding: 0 3px;
    margin-right: 16px;

    &:last-child {
      margin-right: 0;
    }

    &.router-link-exact-active {
      color: $white;
      background-color: $dark;
    }
  }

  .footer__top {
    position: absolute;
    right: 0;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: url('../assets/arrow.svg') 50% 50% no-repeat $dark;
    transform: rotate(180deg);
    cursor: pointer;
  }

</style>
